'use client'

import { useTranslation as _useTranslation } from 'react-i18next'

import { getClientEnvironment } from '@dfds-pax/common'

// Wrapper component or hook that uses useTranslation
export const useTranslation = () => {
  const { t } = _useTranslation()

  // Wrapper function around `t`
  const tDebug = (key: string | string[], options?: any) => {
    // Check if in development mode
    const showKeys = typeof window !== 'undefined' && sessionStorage.getItem('showKeys') === 'true'

    if (showKeys && getClientEnvironment() != 'prod') {
      // Return the key for debugging
      return `"${key}"`
    }
    // Otherwise, return the translated string
    return t(key, options)
  }

  return { t: tDebug }
}
